var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img-lazy',{class:`${_vm.imgClass} ${_vm.variant}`,style:(_vm.imgStyle),attrs:{"blank-src":_vm.disableLazy ? '' : _vm.$icons.LAZY_LOAD,"src":_vm.imgSource},nativeOn:{"error":function($event){return _vm.imgUrlAlt.apply(null, arguments)},"load":function($event){return _vm.imgLoaded.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }